import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('filled', 'test-pipe-2-filled', 'TestPipe2Filled', [["path",{"d":"M16 2a1 1 0 0 1 0 2v14a4 4 0 1 1 -8 0v-14a1 1 0 1 1 0 -2zm-2 2h-4v7h4z"}]]);